import { useMemo, useState } from "react";
import { Button, Flex, Select, Typography, Divider } from "antd";
import useGet from "hooks/useGet";
import useCreate from "hooks/useCreate";
import { getIssueStatusLabel } from "helpers/options/issue_statuses";

const AssignIssue = ({
  issue_group_id,
  refetch,
  current_issue_id,
  handleClose,
}) => {
  const [issue_id, setIssueId] = useState("");
  const [search_query, setSearchQuery] = useState("");

  const { is_fetching, data = [] } = useGet({
    query: ["search_query", search_query],
    path: "/issues",
    context: "list",
    search: {
      per_page: 20,
      "q[id_not_in]": [current_issue_id],
      "q[identifier_or_client_phone_or_client_first_name_or_client_last_name_or_client_city_or_client_post_code_or_client_street_matches]": `%${search_query}%`,
    },
    options: {
      refetchOnWindowFocus: false,
    },
  });

  const { is_saving: is_creating, create: createSubIssue } = useCreate({
    path: "/issue_group_items",
    onSuccess: refetch,
    success_message: "Przypisano podzgłoszenie",
  });

  const onSearch = (value) => setSearchQuery(value);
  const onChange = (id) => setIssueId(id);

  const handleAssign = async () => {
    try {
      await createSubIssue({
        issue_id,
        issue_group_id,
      });
      handleClose();
    } catch (error) {
      console.log(error);
    }
  };
  const issue_options = useMemo(
    () =>
      data.map(({ id, identifier, status, issue_type }) => ({
        label: (
          <>
            {getIssueStatusLabel(status)} {identifier}
          </>
        ),
        value: id,
        disabled: issue_type !== 'normal',
      })),
    [data]
  );

  return (
    <>
      <Divider>Przypisz istniejące zgłoszenie</Divider>
      <div className="p-t-20 p-b-20">
        <Typography.Text>Szukaj zgłoszenia</Typography.Text>
        <Select
          showSearch
          value={issue_id}
          placeholder="Szukaj..."
          style={{
            width: "100%",
          }}
          getPopupContainer={() =>
            document.querySelector("#connect_issue_modal")
          }
          defaultActiveFirstOption={false}
          suffixIcon={is_fetching ? "Proszę czekać..." : null}
          filterOption={false}
          onSearch={onSearch}
          onChange={onChange}
          notFoundContent={null}
          options={issue_options}
        />
      </div>
      <Flex justify="end">
        <Button
          key="submit"
          type="primary"
          disabled={!issue_id}
          loading={is_creating}
          htmlType="button"
          onClick={handleAssign}
        >
          Dodaj
        </Button>
      </Flex>
    </>
  );
};

export default AssignIssue;
